import { withInstall } from '@element-plus/utils'

import Numberal from './src/numberal.vue'

export const ElNumberal = withInstall(Numberal)
export default ElNumberal

export * from './src/numberal'
